import React from "react";
import stylesSCTree from "../SCTree.module.css";

export class TreeAdvancedSearchLegenda extends React.Component {

    render() {
        return <div className={stylesSCTree['tree-item-search__legenda__text']}>
            <div className={stylesSCTree['tree-item-search__legenda__text__title']}>Istruzioni per la ricerca avanzata
            </div>
            <div className={stylesSCTree['tree-item-search__legenda__text__disclaimer']}>(Queste istruzioni valgono solo
                per campi testo e campi preriempiti, mentre sono esclusi campi ricerca per documenti contraddistinti
                dall'etichetta preceduta dal simbolo <strong>'*'</strong>. Per i documenti verranno trovate solo corrispondenze
                esatte
            </div>
            <ul className={stylesSCTree['tree-item-search__legenda__text__contents']}>
                <li><strong>+parola1 +parola2 +parola3</strong> deve contenere queste parole (<u>importante</u> spazio
                    tra
                    gli elementi con +) . Esempio: <strong>+comune +di</strong> trova tutti le voci che contengono
                    sia <strong>comune</strong> sia <strong>di</strong> anche in ordine sparso (vedi terzo risultato):
                    <i>
                        <ul>
                            <li>000 - Compartecipazione acquisto mezzo Polizia locale Val di Fassa - <strong>Comune
                                di</strong> Moena
                            </li>
                            <li>Proroga accordo temporanea messa a disposizione Pellegrin Franco a <strong>Comune
                                di</strong> Soraga
                            </li>
                            <li>102 - sostituzione <strong>comune</strong> pagamenti TIA 2018 San
                                Giovanni <strong>di</strong> Fassa
                            </li>
                        </ul>
                    </i>
                </li>
                <li><strong>-parola</strong> <u>non</u> deve contenere quella parola. Esempio: <strong>-comune</strong> troverà
                    tutte le voci che non contengono <strong>comune</strong>. <u>E' possibile combinare + e -</u>.
                    Esempio:<strong>+comune -di</strong> trova tutte le voci che contengono <strong>comune</strong> ma
                    non <strong>di</strong></li>
                <li><strong>par*, *par, *par*</strong> rispettivamente <u>inizia per</u>, <u>finisce
                    per</u>, <u>contiene</u>. <strong>Par*</strong> può appartenere a qualsiasi parola nella frase. Ad
                    esempio <strong>derog*</strong> trova anche <i>Punto 9 delibera <strong>deroga</strong> Hotel Monti
                        Pallidi</i>
                    Inoltre adesso puoi finalmente anche cercare frasi tipo: <strong>acquisto m*</strong>
                    <i>000 - Compartecipazione <strong>acquisto me</strong>zzo Polizia locale Val di Fassa - Comune di
                        Moena</i>
                    <i>percorso geologico <strong>acquisto m</strong>assi</i>
                    La ricerca deve rispettare la sequenza e non si troveranno risultati in cui un m* si trova in altre posizioni.
                </li>
                <li><strong>acquisto massi</strong> trova la frase scritta in quest'ordine come in precedenza, ma non
                    troverà titoli
                    contenenti, ad esempio <strong>acquisto massimo</strong>
                </li>
                <li><strong>acquisto mezzo && val di</strong> troverà tutti gli elementi che contengono sia <strong>acquisto
                    mezzo</strong> che <strong>val di</strong>.
                    Esempio:
                    <i>000 - Compartecipazione acquisto mezzo Polizia locale Val di Fassa - Comune di Moena</i>
                </li>
                <li><strong>parola1 parola2~N</strong> ricerca per <u>prossimità</u>: trova i documenti in cui le due
                    parole compaiono entro <strong>N</strong> parole di distanza, in qualsiasi ordine. Più N è alto, più
                    la ricerca è permissiva. Esempi:
                    <i>
                        <ul>
                            <li><strong>casa legno~2</strong> trova <i>casa di legno</i>, <i>casa in legno</i></li>
                            <li><strong>riqualificazione funzionale~5</strong> trova <i>riqualificazione urbana e
                                funzionale</i></li>
                            <li><strong>casa legno~0</strong> equivale a frase esatta <i>casa legno</i></li>
                        </ul>
                    </i>
                    <u>Nota:</u> questa sintassi vale solo per i campi documento (etichetta con <strong>'*'</strong>).
                </li>
                <li><strong>parola~N</strong> ricerca <u>fuzzy</u> (con tolleranza agli errori): trova parole simili
                    entro una distanza di modifica di <strong>N</strong> caratteri (0, 1 o 2). Può essere usata anche
                    su più parole contemporaneamente. Se si omette N (<strong>parola~</strong>) viene usato il
                    default <strong>1</strong>. Esempi:
                    <i>
                        <ul>
                            <li><strong>comune~1</strong> trova <i>comune</i>, <i>comuni</i>, <i>comume</i></li>
                            <li><strong>acquisto~2</strong> trova <i>acquisto</i> e varianti con fino a 2 differenze</li>
                            <li><strong>comune~</strong> equivale a <strong>comune~1</strong></li>
                            <li><strong>comune~1 acquisto~1</strong> trova documenti che contengono entrambe le parole,
                                ciascuna con tolleranza 1
                            </li>
                        </ul>
                    </i>
                    <u>Nota:</u> questa sintassi vale solo per i campi documento (etichetta con <strong>'*'</strong>).
                    N=2 è molto permissivo: usare con cautela.
                </li>
                <li><strong>#pattern#</strong> ricerca con <u>espressione regolare</u>: il valore è racchiuso tra
                    cancelletti <strong>#</strong> e viene interpretato come regex. La regex viene applicata ai singoli token
                    del testo (parole), quindi non può attraversare più parole. Usare pattern <strong>lowercase</strong>
                    poiché i token sono analizzati in minuscolo. Esempi:
                    <i>
                        <ul>
                            <li><strong>#lav.*o#</strong> trova <i>lavoro</i>, <i>lavativo</i>, <i>lavaggio</i></li>
                            <li><strong>#riqualific.*#</strong> trova <i>riqualificazione</i>, <i>riqualifica</i></li>
                            <li><strong>#(deliber|approvaz).*#</strong> trova <i>delibera</i> oppure <i>approvazione</i></li>
                            <li><strong>#acqui[rs]t.*#</strong> trova <i>acquisto</i> e <i>acquirente</i></li>
                        </ul>
                    </i>
                    <u>Nota:</u> questa sintassi vale solo per i campi documento (etichetta con <strong>'*'</strong>).
                    Pattern con <strong>.*</strong> iniziale sono molto lenti: evitarli.
                </li>
            </ul>
        </div>
    }
}